import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer';
import Header from '../components/Header';
import '../assets/scss/privacyPolicy.scss';

function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <main>
      <Helmet>
        <title>Política de Privacidad - Delmiro Mendez e Hijo S.A.</title>
        <meta name="description" content="Política de privacidad de Delmiro Mendez e Hijo S.A." />
      </Helmet>
      <Header />
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <div className="privacy-policy-header">
            <h1>{t('privacy-policy.title')}</h1>
          </div>
          <div className="policy-section policy-intro-section">
            <h2>{t('privacy-policy.subtitle')}</h2>
            <p>
              {t('privacy-policy.intro')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section1.title')}</h3>
            <p>
              {t('privacy-policy.section1.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section2.title')}</h3>
            <p>
              {t('privacy-policy.section2.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section3.title')}</h3>
            <p>
              {t('privacy-policy.section3.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section4.title')}</h3>
            <p>
              {t('privacy-policy.section4.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section5.title')}</h3>
            <p>
              {t('privacy-policy.section5.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section6.title')}</h3>
            <p>
              {t('privacy-policy.section6.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section7.title')}</h3>
            <p>
              {t('privacy-policy.section7.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section8.title')}</h3>
            <p>
              {t('privacy-policy.section8.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section9.title')}</h3>
            <p>
              {t('privacy-policy.section9.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section10.title')}</h3>
            <p>
              {t('privacy-policy.section10.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section11.title')}</h3>
            <p>
              {t('privacy-policy.section11.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section12.title')}</h3>
            <p>
              {t('privacy-policy.section12.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section13.title')}</h3>
            <p>
              {t('privacy-policy.section13.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section14.title')}</h3>
            <p>
              {t('privacy-policy.section14.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section15.title')}</h3>
            <p>
              {t('privacy-policy.section15.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section16.title')}</h3>
            <p>
              {t('privacy-policy.section16.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section17.title')}</h3>
            <p>
              {t('privacy-policy.section17.content')}
            </p>
          </div>

          <div className="policy-section">
            <h3>{t('privacy-policy.section18.title')}</h3>
            <p>
              {t('privacy-policy.section18.content')}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default PrivacyPolicy;
